/* What's Inside modal behavior. Native <dialog> supplies focus trap, Escape and
   backdrop; this file adds tab switching, opening states, focus return, body
   scroll lock, and analytics (gtag + dataLayer, never required). */
(function () {
  'use strict';
  if (window.__biwCkModal) return;
  window.__biwCkModal = 1;

  function track(name, payload) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, payload);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) { /* analytics must never break the page */ }
  }

  function init() {
    var dlg = document.getElementById('ck-whats-inside');
    if (!dlg || typeof dlg.showModal !== 'function') return;

    var opener = null;
    var tabs = dlg.querySelectorAll('[data-ckm-tab]');
    // Panels are discovered from the tabs' own aria-controls rather than listed
    // here, so adding a tab in the Liquid needs no matching edit in this file.
    var panels = {};
    var tabNames = [];
    tabs.forEach(function (t) {
      var name = t.getAttribute('data-ckm-tab');
      tabNames.push(name);
      panels[name] = dlg.querySelector('#' + t.getAttribute('aria-controls'));
    });

    var ctxBtn = dlg.querySelector('[data-ckm-ctx]');
    function setCtx(mode) {
      if (!ctxBtn) return;
      var map = {
        components: { l: 'Choose Your Kit', h: '#choose-your-clear-kit' },
        sections:   { l: 'Choose Your Kit', h: '#choose-your-clear-kit' },
        sample:     { l: 'Choose Your Kit', h: '#choose-your-clear-kit' },
        essentials: { l: 'Choose Essentials', h: '/products/clear-kit?variant=51679037391163' },
        expanded:   { l: 'Choose Expanded', h: '/products/clear-kit?variant=51679037456699' },
        builder:    { l: 'Build Your Kit', h: '/collections/build-your-own-clear-kit' }
      };
      var c = map[mode] || map.components;
      ctxBtn.textContent = c.l;
      ctxBtn.setAttribute('href', c.h);
      ctxBtn.hidden = false;
      // Scroll targets close the modal first, product links navigate as-is.
      ctxBtn.onclick = c.h.charAt(0) === '#' ? function (e) {
        e.preventDefault();
        doClose();
        var el = document.getElementById(c.h.slice(1));
        if (el) el.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      } : null;
    }
    function setTab(name) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-ckm-tab') === name;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      tabNames.forEach(function (n) {
        if (panels[n]) panels[n].hidden = n !== name;
      });
      setCtx(name);
      track('clear_kit_modal_tab_change', { tab: name });
    }

    function open(state, from) {
      opener = from || document.activeElement;
      var parts = String(state || 'components').split(':');
      var tab = tabNames.indexOf(parts[0]) !== -1 ? parts[0] : 'components';
      var focus = parts[1] || '';

      dlg.classList.toggle('ckm--builder-focus', focus === 'builder');
      setTab(tab);

      dlg.querySelectorAll('.ckm-bindercol, .ckm-panelblock').forEach(function (b) { b.classList.remove('is-focus'); });
      if (focus === 'essentials') {
        var b1 = dlg.querySelector('#ckm-b1');
        if (b1) b1.classList.add('is-focus');
      } else if (focus === 'expanded') {
        ['#ckm-b2', '#ckm-b3'].forEach(function (id) {
          var b = dlg.querySelector(id);
          if (b) b.classList.add('is-focus');
        });
      }

      document.body.classList.add('ckm-open');
      cleaned = false;
      dlg.showModal();
      dlg.querySelector('.ckm-body').scrollTop = 0;
      if (focus === 'essentials' || focus === 'expanded') {
        var target = dlg.querySelector(focus === 'essentials' ? '#ckm-b1' : '#ckm-b2');
        if (target) target.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
      setCtx(focus || tab);
      track('clear_kit_modal_open', { state: state || 'components', trigger_location: (from && from.getAttribute && from.getAttribute('data-cmp-loc')) || 'unknown' });
    }

    var cleaned = true;
    function cleanup() {
      if (cleaned) return;
      cleaned = true;
      document.body.classList.remove('ckm-open');
      track('clear_kit_modal_close', {});
      if (opener && opener.focus) opener.focus();
      opener = null;
    }
    function doClose() { dlg.close(); cleanup(); }
    // The close event alone is not reliable in every embedding, so every close
    // path also calls cleanup() directly; cleanup() is idempotent.
    dlg.addEventListener('close', cleanup);
    dlg.addEventListener('cancel', function () { setTimeout(cleanup, 0); });

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { setTab(t.getAttribute('data-ckm-tab')); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          // Cycle by index so the roving tabstop keeps working past two tabs.
          var i = tabNames.indexOf(t.getAttribute('data-ckm-tab'));
          var step = e.key === 'ArrowRight' ? 1 : -1;
          var other = tabNames[(i + step + tabNames.length) % tabNames.length];
          setTab(other);
          dlg.querySelector('[data-ckm-tab="' + other + '"]').focus();
        }
      });
    });

    dlg.querySelector('[data-ckm-close]').addEventListener('click', doClose);

    // Backdrop click: the dialog element itself is the click target only when
    // the click lands outside its content box.
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) {
        var r = dlg.getBoundingClientRect();
        var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (!inside) doClose();
      }
    });


    dlg.querySelectorAll('details[data-ckm-details]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) track('clear_kit_section_list_expand', { list: d.getAttribute('data-ckm-details') });
      });
    });

    // Any element on the page can open the modal.
    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest ? e.target.closest('[data-ck-modal-open]') : null;
      if (!el) return;
      e.preventDefault();
      open(el.getAttribute('data-ck-modal-open'), el);
    });

    // Smooth scrolling for same-page anchors, honoring reduced motion.
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      var target = id && document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      history.replaceState(null, '', '#' + id);
    });
  }

  /* Persistent purchase navigation (brief section 14). Markup is injected so the
     template stays untouched; the bars are pure enhancement. Desktop: compact
     top bar. Mobile: bottom bar with safe-area padding. Both appear only after
     the visitor scrolls past the hero, and only on the CLEAR Kits page. */
  function initSticky() {
    var hero = document.querySelector('.biwhm-hero');
    var cards = document.getElementById('choose-your-clear-kit');
    if (!hero || !cards) return;

    var bar = document.createElement('div');
    bar.className = 'ckstick ckstick--desktop';
    bar.setAttribute('aria-label', 'CLEAR Kit quick navigation');
    bar.innerHTML =
      '<a class="ckstick-brand" href="#choose-your-clear-kit" data-cmp-event="clear_kit_sticky_choose_click" data-cmp-loc="sticky_bar">CLEAR Kit</a>' +
      '<span class="ckstick-links">' +
      '<a href="/products/clear-kit?variant=51679037391163" data-cmp-event="clear_kit_essentials_click" data-cmp-loc="sticky_bar">Essentials</a>' +
      '<a href="/products/clear-kit?variant=51679037456699" data-cmp-event="clear_kit_expanded_click" data-cmp-loc="sticky_bar">Expanded</a>' +
      '<a href="/collections/build-your-own-clear-kit" data-cmp-event="clear_kit_builder_click" data-cmp-loc="sticky_bar">Build Your Own</a>' +
      '<a href="/collections/clear-kit-whats-included" data-ck-modal-open="components" data-cmp-event="clear_kit_sticky_inside_open" data-cmp-loc="sticky_bar">See What&rsquo;s Inside</a>' +
      '</span>';

    var mbar = document.createElement('div');
    mbar.className = 'ckstick ckstick--mobile';
    mbar.setAttribute('aria-label', 'CLEAR Kit quick actions');
    mbar.innerHTML =
      '<a class="ckstick-primary" href="#choose-your-clear-kit" data-cmp-event="clear_kit_sticky_choose_click" data-cmp-loc="sticky_bar">Choose Your Kit</a>' +
      '<a class="ckstick-secondary" href="/collections/clear-kit-whats-included" data-ck-modal-open="components" data-cmp-event="clear_kit_sticky_inside_open" data-cmp-loc="sticky_bar">What&rsquo;s Inside</a>';

    document.body.appendChild(bar);
    document.body.appendChild(mbar);

    var seen = false;
    function show(on) {
      bar.classList.toggle('is-on', on);
      mbar.classList.toggle('is-on', on);
      document.body.classList.toggle('ckstick-active', on);
      if (on && !seen) { seen = true; track('clear_kit_sticky_bar_view', {}); }
    }
    function update() { show(hero.getBoundingClientRect().bottom < 1); }
    // IntersectionObserver where it works, plus scroll/resize listeners and a
    // slow interval: some embeddings fail to deliver observer or scroll events,
    // and the bar must never depend on a single delivery mechanism.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(update, { rootMargin: '-1px 0px 0px 0px' }).observe(hero);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    setInterval(update, 600);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); initSticky(); });
  else { init(); initSticky(); }
})();
